import {SummaryModel} from '../../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';

export class PrescriptionMedicineSummaryModel implements SummaryModel{
    permissions: PermissionsModel;
    id: number;
    label: string;
}
